import { useQuery } from 'urql';

import { graphql } from '@/__generated__';
import { AutoExposureBiProvider, ExposureTileFilter } from '@/__generated__/graphql';

const ExposureTileQuery = graphql(/* GraphQL */ `
  query ExposureTile($environmentId: BigInt!, $filter: ExposureTileFilter!) {
    environment(id: $environmentId) {
      applied {
        exposureTile(filter: $filter) {
          accountId
          projectId
          uniqueId
          freshnessStatus
          quality
          upstreamStats
          maxSnapshottedAt
          description
          environmentId
          filePath
          meta
          exposureType
          name
          packageName
          resourceType
          tags
          healthIssues
          autoBiProvider
        }
      }
    }
  }
`);

type ExposureProps = {
  uniqueId?: string | null;
  environmentId?: number | null;
  autoBiProvider?: string | null;
  biResourceId?: string | null;
  pause?: boolean;
};

export const useExposureTileQuery = ({
  environmentId,
  uniqueId,
  autoBiProvider,
  biResourceId,
  pause,
}: ExposureProps) => {
  const filter: ExposureTileFilter = {
    uniqueId: uniqueId || '',
    biResourceId: biResourceId || '',
    autoBiProvider: autoBiProvider as AutoExposureBiProvider,
  };

  const [query, refetch] = useQuery({
    query: ExposureTileQuery,
    variables: { environmentId: environmentId!, filter },
    pause: pause || !environmentId || !uniqueId,
  });

  return [
    {
      ...query,
      data: query.data?.environment.applied?.exposureTile ?? null,
    },
    refetch,
  ] as const;
};

export type ExposureNode = NonNullable<
  ReturnType<typeof useExposureTileQuery>[0]['data']
>;
